<template>
  <div class="footer-component">
    <div class="time-section">
      <span> Время: {{ hours }}:{{ minutes }} </span>
    </div>
    <div class="logo-section">
      <router-link to="/" class="d-flex align-center">
        <img src="/logo-small.svg" alt="logo" />
      </router-link>
    </div>
    <div class="profile-section">
      <div class="avatar">
        <font-awesome-icon icon="user" />
      </div>
      <div class="name">
        <span>Федоров Олег</span>
      </div>
    </div>
  </div>
</template>

<script>
  import mixinGetDatatime from '@/mixins/get-datatime'

  export default {
    name: 'Footer',
    mixins: [mixinGetDatatime],
  }
</script>

<style lang="less" scoped>
.footer-component {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #26272b;
  padding: 8px 24px;

  .time-section {
    span {
      color: #ffffff;
    }
  }

  .profile-section {
    display: flex;
    align-items: center;
    .avatar {
      margin-right: 8px;
      padding: 2px 4px;
      background-color: #0f0f0f;
      svg {
        width: 18px;
        .fill-svg(#ffffff);
      }
    }
    .name {
      color: #ffffff;
    }
  }
}
</style>
